var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalineAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V4H7C5.89543 4 5 4.89543 5 6V6.25H19V6C19 4.89543 18.1046 4 17 4H12.75V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.25V7.75H5V16.7711C5 17.4985 5.4822 18.1378 6.18161 18.3376C7.43559 18.6959 8.7144 18.936 10.0017 19.058C10.0317 19.5833 10.4672 20 11 20H11.25V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V20H13C13.5328 20 13.9683 19.5833 13.9983 19.058C15.2856 18.936 16.5644 18.6959 17.8184 18.3376C18.5178 18.1378 19 17.4985 19 16.7711V13.75H16C15.5858 13.75 15.25 13.4142 15.25 13C15.25 12.5858 15.5858 12.25 16 12.25H19V10.75H14C13.5858 10.75 13.25 10.4142 13.25 10C13.25 9.58579 13.5858 9.25 14 9.25H19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalineAlt);
export default __webpack_public_path__ + "static/media/saline-alt.af50d5cf012e334be582093e2ae8fc63.svg";
export { ForwardRef as ReactComponent };